export const initialState = {
    data: {},
    isFullValue: false
  };
  
  const dataAplicationReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_DATA_QUESTIONNAIRE":
        return {
          ...state,
          data: action.data,
          isFullValue: action.isFullValue,
        };
      default:
        return state;
    }
  };
  
  export default dataAplicationReducer;
  